import React from 'react';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import SimpleOrderForm from './simple-order/form';

// components

export default (props) => {
    const routes = [{
        path: '/simple-order/:arg1',
        Component: SimpleOrderForm,
    }];

    return (
        <Router>
            <div>
                <Switch>
                    <Redirect from="/" to="/simple-order/form" exact/>
                    {routes.map(({ path, Component }, key) => <Route exact path={path} component={Component} key={key} />)}
                </Switch>
            </div>
        </Router>
    );
};